import { Router, NavigationStart, NavigationEnd, NavigationError } from '@angular/router';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
function RouterLoadingIndicatorComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵdomElementStart(0, "div", 0)(1, "span", 1);
    i0.ɵɵdomElement(2, "span", 2)(3, "span", 2)(4, "span", 2);
    i0.ɵɵdomElementEnd()();
  }
}
export let RouterLoadingIndicatorComponent = /*#__PURE__*/(() => {
  class RouterLoadingIndicatorComponent {
    constructor(router) {
      this.router = router;
      router.events.subscribe(event => {
        if (event instanceof NavigationStart) {
          this.display = true;
        }
        if (event instanceof NavigationEnd) {
          this.display = false;
        }
        if (event instanceof NavigationError) {
          this.display = false;
          console.log(event.error);
        }
      });
    }
    static {
      this.ɵfac = function RouterLoadingIndicatorComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || RouterLoadingIndicatorComponent)(i0.ɵɵdirectiveInject(i1.Router));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: RouterLoadingIndicatorComponent,
        selectors: [["router-loading-indicator"]],
        decls: 1,
        vars: 1,
        consts: [[2, "display", "flex", "height", "90vh", "align-items", "center", "justify-content", "center"], [1, "spinner"], [1, "dot"]],
        template: function RouterLoadingIndicatorComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵconditionalCreate(0, RouterLoadingIndicatorComponent_Conditional_0_Template, 5, 0, "div", 0);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.display ? 0 : -1);
          }
        },
        styles: [".spinner[_ngcontent-%COMP%]{width:70px;height:15px;text-align:center}.dot[_ngcontent-%COMP%]{background:#000;display:inline-block;border-radius:50%;width:15px;height:15px;margin:0 1px;animation:.6s linear 0s alternate none infinite running _ngcontent-%COMP%_load;opacity:0}.dot[_ngcontent-%COMP%]:nth-child(2){animation-delay:.2s}.dot[_ngcontent-%COMP%]:nth-child(3){animation-delay:.4s}@keyframes _ngcontent-%COMP%_load{0%{opacity:0;transform:scale(.8)}to{opacity:1;transform:scale(1)}}\n\n/*# sourceMappingURL=loading-indicator.component.ts-angular-inline--1.css.map*/"]
      });
    }
  }
  return RouterLoadingIndicatorComponent;
})();